<template>
  <div class="contain">
    <div class="userInfo">
      <div style="overflow: hidden;">
        <div class="respect">{{ sayHello }}</div>
        <div class="userName">{{ nickname }}</div>
      </div>
      <div
        style="margin-top:6px;overflow: hidden;color:#333;font-size:18px;font-family:  PingFang-SC-Medium;"
      >
        <div style="float:left;line-height: 25px;">当前登录单位：</div>
        <div style="float:left;line-height: 25px">{{ userInfo.unit }}</div>
      </div>
    </div>
    <div class="title">
      <a-icon type="file-protect" style="color:#3D73DD;font-size:30px;margin-right:17px" />
      <span
        style="font-weight:600;display: inline-block;font-family: PingFang-SC-Bold;font-size:26px;line-height:37px;color:#1C2D51"
      >流程中心</span>
    </div>
    <div class="content">
      <div class="contentLeft">
        <a-tabs v-model="activeKey" @change="callback">
          <a-tab-pane key="1" tab="待办">
            <a-table
              :columns="columns"
              :data-source="data"
              :loading="loading"
              :pagination="false"
              :rowKey="
                (record) => {
                  record.process_base_id
                }
              "
              :customRow="rowClick"
            >
              <div slot="name" slot-scope="text" style="position: relative">
                <!--                <a-badge color="red"/>-->
                <!--<span class="tag" v-if="scope.tag"></span>-->
                <span style="display: inline-block;">{{ text }}</span>
              </div>
            </a-table>
          </a-tab-pane>
          <a-tab-pane key="2" tab="已办" force-render>
            <a-table
              :columns="columns"
              :data-source="data"
              :loading="loading"
              :pagination="false"
              :rowKey="(record) => record.process_base_id"
              :customRow="rowClick"
            >
              <div slot="name" slot-scope="text" style="position: relative">
                <!--                <a-badge color="red"/>-->
                <!--<span class="tag" v-if="scope.tag"></span>-->
                <span style="display: inline-block;">{{ text }}</span>
              </div>
            </a-table>
          </a-tab-pane>
          <!-- <a-tab-pane key="3" tab="完成">
            <a-table
              :columns="columns"
              :data-source="data"
              :loading="loading"
              :pagination="false"
              :rowKey="(record) => record.process_base_id"
              :customRow="rowClick"
            >
              <div slot="name" slot-scope="text" style="position: relative">
                <a-badge color="red"/>
                <span class="tag" v-if="scope.tag"></span>
                <span style="display: inline-block;">{{ text }}</span>
              </div>
            </a-table>
          </a-tab-pane>-->
          <a-tab-pane key="4" tab="草稿">
            <a-table
              :columns="columns"
              :data-source="data"
              :loading="loading"
              :pagination="false"
              :rowKey="(record) => record.process_base_id"
              :customRow="rowClick"
            >
              <div slot="name" slot-scope="text" style="position: relative">
                <!--                <a-badge color="red"/>-->
                <!--<span class="tag" v-if="scope.tag"></span>-->
                <span style="display: inline-block;">{{ text }}</span>
              </div>
            </a-table>
          </a-tab-pane>
          <!-- <a-tab-pane key="5" tab="阅读">
            <template v-slot:tab>
            <a-badge :dot="show">
              阅读
            </a-badge>
            </template>
            <a-table
              :columns="columns"
              :data-source="data"
              :loading="loading"
              :pagination="false"
              :rowKey="(record) => record.process_base_id"
              :customRow="rowClick"
            >
              <div slot="name" slot-scope="text" style="position: relative">
                <a-badge color="red"/>
                <span class="tag" v-if="scope.tag"></span>
                <span style="display: inline-block;">{{ text }}</span>
              </div>
            </a-table>
          </a-tab-pane>-->
        </a-tabs>
        <div id="more" @click="onMoreClick">
          更多
          <a-icon type="double-right" />
        </div>
      </div>
      <div class="contentRight">
        <div class="inside">
          <div
            style="border-bottom:1px solid #e8e8e8;height:50px;padding-left:20px;padding-top:15px;"
          >
            <card-title title="内部公告" id="inside" :moreClick="moreClick" />
          </div>
          <div class="table gonggao" style="margin-top:10px;height:175px;overflow: hidden">
            <a-table
              :columns="columnsInside"
              :data-source="innerData"
              :pagination="false"
              :customRow="rowClickReport"
              :rowKey="(record) => record.process_base_id"
            >
              <!--              <div slot="name" slot-scope="text">-->
              <!--                &lt;!&ndash;                <span class="tag" v-if="scope.tag"></span>&ndash;&gt;-->
              <!--                <span style="display: inline-block;margin-left:15px;">{{ text }}</span>-->
              <!--              </div>-->
            </a-table>
          </div>
        </div>
        <div class="government">
          <div
            style="border-bottom:1px solid #e8e8e8;height:50px;padding-left:20px;padding-top:15px;"
          >
            <card-title title="政府公告" id="government" :moreClick="moreClick"></card-title>
          </div>
          <div class="table gonggao" style="margin-top:10px;height:175px;overflow: hidden">
            <a-table
              :columns="columnsInside"
              :data-source="governmentData"
              :pagination="false"
              :customRow="rowClickReport"
              :rowKey="(record) => record.process_base_id"
            >
              <div slot="name" slot-scope="text" style="position: relative">
                <!--                <span class="tag" v-if="scope.tag"></span>-->
                <span style="display: inline-block;margin-left:15px;">{{ text }}</span>
              </div>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { service } from './service'
import cardTitle from './components/cardTitle'
import { mapGetters } from 'vuex'

const columns = [
  {
    title: '业务事项',
    dataIndex: 'process_base_title',
    key: 'process_base_title',
    // scopedSlots: { customRender: 'name' },
    ellipsis: true,
    width: '250px'
  },
  {
    title: '当前状态',
    dataIndex: 'process_status',
    key: 'process_status'
  },
  {
    title: '操作人',
    dataIndex: 'drafter_name',
    key: 'drafter_name'
  },
  {
    title: '操作时间',
    dataIndex: 'process_base_arrive_date',
    key: 'process_base_arrive_date',
    width: '170px'
  }
]
const columnsInside = [
  {
    title: 'report_message_name',
    dataIndex: 'report_message_name',
    key: 'report_message_name',
    // scopedSlots: { customRender: 'name' },
    ellipsis: true,
    width: '150px'
  },
  // {
  //   title: 'address',
  //   dataIndex: 'address',
  //   key: 'address'
  // },
  {
    title: 'report_message_create_time',
    dataIndex: 'report_message_create_time',
    key: 'report_message_create_time',
    width: '130px'
  }
]
export default {
  name: 'Index',
  components: {
    cardTitle
  },
  data() {
    return {
      show: false, // 默认不显示徽标数
      activeKey: '1', // 默认展开待办
      sayHello: '上午好！',
      loading: true,
      columns, // 流程列头
      columnsInside, // 公告列头
      // false: false,
      // doneData: [],
      // draftData: [],
      // finishData: [],
      innerData: [
        // 内部公告数据
        {
          id: 1,
          title: '情暖老人心,贫困老人心脏病治疗',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23',
          tag: true
        },
        {
          id: 2,
          title: '爱心2008贫困家庭病残儿童救助项目',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23'
        },
        {
          id: 3,
          title: '情暖老人心,贫困老人心脏病治疗',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23'
        },
        {
          id: 4,
          title: '爱心2008贫困家庭病残儿童救助项目',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23',
          tag: true
        },
        {
          id: 5,
          title: '情暖老人心,贫困老人心脏病治疗',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23',
          tag: true
        },
        {
          id: 6,
          title: '爱心2008贫困家庭病残儿童救助项目',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23'
        },
        {
          id: 7,
          title: '情暖老人心,贫困老人心脏病治疗',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23',
          tag: true
        }
      ],
      governmentData: [
        // 政府公告数据
        {
          id: 8,
          title: '情暖老人心,贫困老人心脏病治疗',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23',
          tag: true
        },
        {
          id: 9,
          title: '爱心2008贫困家庭病残儿童救助项目',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23'
        },
        {
          id: 10,
          title: '情暖老人心,贫困老人心脏病治疗',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23'
        },
        {
          id: 11,
          title: '爱心2008贫困家庭病残儿童救助项目',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23',
          tag: true
        },
        {
          id: 12,
          title: '情暖老人心,贫困老人心脏病治疗',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23',
          tag: true
        },
        {
          id: 13,
          title: '爱心2008贫困家庭病残儿童救助项目',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23'
        },
        {
          id: 14,
          title: '情暖老人心,贫困老人心脏病治疗',
          address: '黄埔区行政处',
          time: '2020-5-20 16:23',
          tag: true
        }
      ],
      data: [] // 流程列表数据
    }
  },
  created() {
    const date = new Date()
    const hours = date.getHours()
    if (hours && hours < 12) {
      this.sayHello = '上午好！'
    } else if (hours && hours >= 12 && hours < 14) {
      this.sayHello = '中午好！'
    } else if (hours && hours >= 14 && hours <= 18) {
      this.sayHello = '下午好！'
    } else {
      this.sayHello = '晚上好！'
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'nickname']) // vuex中的用户信息
  },
  mounted() {
    this.getProcessList({ process_label: 'Dealt' })
    this.reportMessageForPage({ report_message_type: '内部公告' })
    this.reportMessageForPage({ report_message_type: '政府公告' })
    // service.getProcessList({ process_label: 'Reader' }).then(response => {
    //   if (response && response.length > 0) {
    //     this.show = true
    //   }
    // })
  },
  methods: {
    // tab切换
    callback(value) {
      if (value === '1') {
        this.getProcessList({ process_label: 'Dealt' })
      } else if (value === '2') {
        this.getProcessList({ process_label: 'Done' })
      } else if (value === '3') {
        this.getProcessList({ process_label: 'Complete' })
      } else if (value === '4') {
        this.getProcessList({ process_label: 'Draft' })
      } else if (value === '5') {
        this.getProcessList({ process_label: 'Reader' })
      }
      this.activeKey = value
    },
    // 流程更多，点击跳转
    onMoreClick() {
      let pageType = 'todo'
      if (this.activeKey && this.activeKey === '1') {
        pageType = 'todo'
      } else if (this.activeKey && this.activeKey === '2') {
        pageType = 'done'
      } else if (this.activeKey && this.activeKey === '3') {
        pageType = 'finish'
      } else if (this.activeKey && this.activeKey === '4') {
        pageType = 'draft'
      } else if (this.activeKey && this.activeKey === '5') {
        pageType = 'reader'
      }
      this.$router.push({ path: '/assit/process/processList', query: { pageType: pageType } })
    },
    // 获取流程列表
    getProcessList(data) {
      this.data = []
      this.loading = true
      service.getProcessList(data).then((response) => {
        this.data = response || []
        this.loading = false
        if (this.activeKey === '5') {
          this.show = false
        }
      })
    },
    // 获取公告列表
    reportMessageForPage(data) {
      service.reportMessageForPage(data).then((response) => {
        if (data.report_message_type === '内部公告') {
          this.innerData = response.records || []
        }
        if (data.report_message_type === '政府公告') {
          this.governmentData = response.records || []
        }
      })
    },
    // 公告更多，点击事件
    moreClick(value) {
      this.$router.push({ path: '/assit/report/reportList', query: { pageType: value } })
    },
    rowClick(record, type) {
      return {
        on: {
          dblclick: (event) => {
            // console.log(record, type)
            const params = {
              process_base_work_number: record.process_base_work_number,
              process_base_status: record.process_base_status,
              process_config_step: record.process_config_step
            }
            let type = 'view'
            if (this.activeKey && this.activeKey === '1') {
              // 待办分两种类型，待审批和被退回拟稿
              if (record.process_base_status && record.process_base_status === 'Approval') {
                type = 'approval'
              } else if (
                record.process_base_status &&
                record.process_base_status === 'ReturnDraft'
              ) {
                type = 'relaunch'
              } else if (
                  record.process_base_status &&
                  record.process_base_status === 'Finish'
              ) {
                type = 'approvalFund'
              }
            } else if (
              this.activeKey &&
              (this.activeKey === '2' || this.activeKey === '3' || this.activeKey === '5')
            ) {
              // 完成即为展示页面
              type = 'view'
            } else if (this.activeKey && this.activeKey === '4') {
              // 草稿页面
              type = 'draft'
            }
            if (record.process_config_type && record.process_config_type === 'projectFund' || record.process_config_type === 'projectActivity') {
              // 项目资金帮扶 或 项目服务帮扶
              params.processConfigType = record.process_config_type
              this.$router.push({
                path: '/assit/compositeAssit/increaseItem',
                query: { pageType: type, processData: JSON.stringify(params) }
              })
            } else if (
              record.process_config_type &&
              record.process_config_type === 'projectActivity'
            ) {
              // 活动帮扶
              this.$router.push({
                path: '/assit/compositeAssit/increaseItem',
                query: { pageType: type, processData: JSON.stringify(params) }
              })
            } else if (
              record.process_config_type &&
              record.process_config_type === 'individualCase'
            ) {
              // 个案帮扶
              this.$router.push({
                path: '/assit/compositeAssit/increaseAssitPeople',
                query: { pageType: type, processData: JSON.stringify(params) }
              })
            } else if (
              record.process_config_type &&
              record.process_config_type === 'ghReleaseOfFunds'
            ) {
              // 资金帮扶-帮侬一把
              this.$router.push({
                path: '/assit/compositeAssit/fundAssit',
                query: { pageType: type, processData: JSON.stringify(params) }
              })
            } else if (
              record.process_config_type &&
              record.process_config_type === 'ghActivityConfirmation'
            ) {
              // 活动帮扶-帮侬一把
              this.$router.push({
                path: '/assit/compositeAssit/givemeActive',
                query: { pageType: type, processData: JSON.stringify(params) }
              })
            } else if (
              record.process_config_type &&
              record.process_config_type === 'internalDocuments'
            ) {
              //   文件管理
              this.$router.push({
                path: '/assit/contentManagement/increaseFile',
                query: { pageType: type, processData: JSON.stringify(params) }
              })
            } else if (
              record.process_config_type &&
              record.process_config_type === 'reportMessage'
            ) {
              // 公告发布
              this.$router.push({
                path: '/assit/contentManagement/increaseReport',
                query: { pageType: type, processData: JSON.stringify(params) }
              })
            }
          }
        }
      }
    },
    rowClickReport(record, type) {
      // 公告
      return {
        on: {
          dblclick: (event) => {
            // console.log(record, type)
            const params = {
              process_base_work_number: record.process_base_work_number,
              process_base_status: record.process_base_status
            }
            const type = 'view'
            this.$router.push({
              path: '/assit/contentManagement/increaseReport',
              query: { pageType: type, processData: JSON.stringify(params) }
            })
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "../style.less";
/*/deep/或者>>>*/
.contain {
  .userInfo {
    overflow: hidden;
    margin: 55px 0 50px 0;
    .respect {
      float: left;
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      font-weight: bold;
      color: #333;
      margin-right: 15px;
      line-height: 33px;
    }
    .userName {
      float: left;
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      font-weight: 600;
      color: #333;
      line-height: 33px;
    }
  }
  .content {
    margin-top: 21px;
    overflow: hidden;
    .contentLeft {
      height: 527px;
      overflow: hidden;
      background: #fff;
      float: left;
      width: 800px;
      border-radius: 2px;
      padding: 5px 0px 22px 40px;
      position: relative;
      margin-right: 15px;
      #more {
        position: absolute;
        right: 20px;
        color: #3d73dd;
        cursor: pointer;
        top: 17px;
        font-size: 14px;
      }
      #more:hover {
        color: #0f3e92;
      }
      .tag {
        width: 6px;
        height: 6px;
        background: #ff3535;
        border-radius: 50%;
        display: inline-block;
        position: absolute;
        top: 13px;
        left: 0;
      }
      /deep/ .ant-empty.ant-empty-normal {
        margin: 165px auto 0;
      }
      /deep/ .ant-spin.ant-spin-spinning {
        margin-top: 70px;
      }
    }
    .contentRight {
      float: left;
      width: 385px;
      /deep/ .ant-table-row-cell-break-word {
        padding-left: 15px;
      }
      .inside {
        width: 100%;
        height: 258px;
        background: #fff;
        margin-bottom: 11px;
        border-radius: 2px;
        /deep/ .ant-empty.ant-empty-normal {
          margin: 45px auto 0;
        }
      }
      .government {
        width: 100%;
        height: 258px;
        background: #fff;
        border-radius: 2px;
        /deep/ .ant-empty.ant-empty-normal {
          margin: 45px auto 0;
        }
      }
    }
  }
  /deep/ .ant-tabs-nav-container {
    font-size: 16px;
    line-height: 22px;
    color: #333;
  }
  /deep/ .ant-tabs {
    width: 100%;
    height: 100%;
  }
  /deep/ .ant-tabs-tab {
    font-weight: 600;
  }
  /deep/ .ant-tabs-nav .ant-tabs-tab {
    margin-right: 87px;
  }
  /deep/ .ant-tabs-bar {
    margin-bottom: 10px;
  }
  .gonggao {
    /deep/ .ant-table-thead {
      display: none;
    }
  }
  /deep/ .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px 0;
    overflow-wrap: break-word;
  }
  /deep/ .ant-table-thead > tr > th {
    background: #fff;
    border-bottom: 0;
  }
  /deep/ .ant-table-placeholder {
    border: none;
    padding: 0;
  }
  /deep/ .ant-table-tbody > tr > td {
    border: none;
    padding: 0;
    line-height: 34px;
  }
  /deep/ .ant-table-tbody .ant-table-row:nth-child(even) {
    background: #fff;
  }
  /deep/ .ant-table {
    font-size: 14px;
    color: #333;
  }
  /deep/ .ant-badge {
    font-size: 16px;
  }
  /deep/ .ant-table-row:hover {
    cursor: pointer;
  }
}
</style>
